interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const UsdV2 = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_13944_140908)">
      <rect
        width="99.9999"
        height="100"
        rx="49.9999"
        fill="#409443"
      />
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#409443"
      />
      <path
        d="M46.7692 85V76.8129C44.3077 76.54 41.7063 75.885 38.965 74.8479C36.2797 73.7563 33.958 72.3372 32 70.5906L37.3706 62.4854C39.4965 64.0136 41.5105 65.1871 43.4126 66.0058C45.3706 66.8246 47.3566 67.2339 49.3706 67.2339C53.9021 67.2339 56.1678 65.3509 56.1678 61.5848C56.1678 60.1657 55.6364 58.9649 54.5734 57.9825C53.5105 56.9454 52.1399 55.9903 50.4615 55.117C48.7832 54.2437 46.993 53.3431 45.0909 52.4152C43.1888 51.4873 41.3986 50.423 39.7203 49.2222C38.042 48.0214 36.6713 46.5751 35.6084 44.883C34.5455 43.1365 34.014 41.0351 34.014 38.5789C34.014 34.54 35.1608 31.2105 37.4545 28.5906C39.7483 25.9162 42.8531 24.1969 46.7692 23.4328V15H54.9091V23.269C57.5944 23.6511 59.9441 24.4425 61.958 25.6433C63.972 26.8441 65.7902 28.2904 67.4126 29.9825L61.2028 36.8596C59.6923 35.4951 58.2378 34.4854 56.8392 33.8304C55.4406 33.1209 53.8462 32.7661 52.0559 32.7661C50.042 32.7661 48.5035 33.1754 47.4406 33.9942C46.3776 34.8129 45.8462 36.1501 45.8462 38.0058C45.8462 39.3158 46.3776 40.4347 47.4406 41.3626C48.5035 42.2359 49.8741 43.0819 51.5524 43.9006C53.2308 44.7193 55.021 45.5653 56.9231 46.4386C58.8252 47.3119 60.6154 48.3762 62.2937 49.6316C63.972 50.8869 65.3427 52.4152 66.4056 54.2164C67.4685 55.963 68 58.1462 68 60.7661C68 64.6959 66.8811 68.0799 64.6434 70.9181C62.4615 73.7018 59.2168 75.5575 54.9091 76.4854V85H46.7692Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_13944_140908">
        <rect
          width="99.9999"
          height="100"
          rx="49.9999"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
